export const nvl = <T>(value: T | undefined, defaultValue: T) =>
  value ? value : defaultValue;
